import './App.css';
import { Suspense } from 'react';
//import { Interaction } from './Interaction.jsx'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './Pages/HomePage.jsx';

function App() {
    return (
        <Router basename={'/widgets/v02/'}>
            <Suspense fallback={<div />}>
                <Routes>
                    <Route exact path=":channelId/:interactionId/:jwt?" element={<HomePage/>} />
                </Routes>
            </Suspense>
        </Router>
    );
}

export default App;
